import { render, staticRenderFns } from "./TablePharmacistForm.vue?vue&type=template&id=ca54a474&scoped=true&"
import script from "./TablePharmacistForm.vue?vue&type=script&lang=ts&"
export * from "./TablePharmacistForm.vue?vue&type=script&lang=ts&"
import style0 from "./TablePharmacistForm.vue?vue&type=style&index=0&id=ca54a474&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca54a474",
  null
  
)

export default component.exports